import { Action } from '@ngrx/store';

import {SHIPMENT_HISTORY_FILTER, SHIPMENT_HISTORY_LOAD} from '../actions';
import {ActionWithPayload} from './index';

export interface ShipmentHistoryState {
  initialData: any[];
  filter: string;
  filteredData: any[];
}

export function shipmentHistoryReducer(
  state = {
    initialData: [],
    filter: '',
    filteredData: []
  }, action: ActionWithPayload<ShipmentHistoryState>) {
  switch (action.type) {
    case SHIPMENT_HISTORY_LOAD:
      return {
        initialData: action.payload,
        filter: '',
        filteredData: []
      };

    case SHIPMENT_HISTORY_FILTER:
      return {
        ...state,
        filter: action.payload,
        filteredData: state.initialData.filter(data => data.consignment_no === action.payload)
      };


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/shipment-history.reducer.ts